import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getUserType, normalizeMonthIds } from "../../assets/helpers";

const TELECALLER_CASES_API_URL = "/telecaller/allocated-cases/";
const TELECALLER_FIELD_AGENT_API_URL = "/telecaller/field-agents-list/";
const TELECALLER_FIELD_AGENT_DETAILS_API_URL =
  "/telecaller/field-agents-case-list";
const TELECALLER_FEEDBACK_DETAILS = "telecaller/feedback-details";
const TELECALLER_CALLBACK_LIST = "/telecaller/callback-list/";
const TELECALLER_PTP_LIST = "/telecaller/ptp-list/";

export const fetchTelecallerAllocatedCase = createAsyncThunk(
  "agency/fetchTelecallerAllocatedCase",
  async (params, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;
      if (!token) {
        return;
      }
      const queryParams = { ...params };

      if (Array.isArray(params?.languages) && params?.languages.length > 0) {
        queryParams.languages = params.languages.join(",");
      }
      if (Array.isArray(params?.region) && params?.region.length > 0) {
        queryParams.region = params.region.join(",");
      }

      if (Array.isArray(params?.portfolios) && params?.portfolios.length > 0) {
        queryParams.portfolio = params.portfolios.join(",");
        delete queryParams.portfolios;
      }
      if (Array.isArray(params?.months) && params?.months.length > 0) {
        queryParams.month = normalizeMonthIds(params.months);
        delete queryParams.months;
      }

      if (Array.isArray(params?.buckets) && params?.buckets.length > 0) {
        queryParams.bucket = params.buckets.join(",");
        delete queryParams.buckets;
      }
      if (Array.isArray(params?.branches) && params?.branches.length > 0) {
        queryParams.branch = params.branches.join(",");
        delete queryParams.branches;
      }

      if (
        Array.isArray(params?.supervisors) &&
        params?.supervisors.length > 0
      ) {
        queryParams.supervisor = params.supervisors.join(",");
        delete queryParams.supervisors;
      }

      if (Array.isArray(params?.teamleads) && params?.teamleads.length > 0) {
        queryParams.teamlead = params.teamleads.join(",");
        delete queryParams.teamleads;
      }

      if (
        Array.isArray(params?.telecallers) &&
        params?.telecallers.length > 0
      ) {
        queryParams.telecaller = params.telecallers.join(",");
        delete queryParams.telecallers;
      }
      if (
        Array.isArray(params?.field_agents) &&
        params?.field_agents.length > 0
      ) {
        queryParams.field_agent = params.field_agents.join(",");
        delete queryParams.field_agents;
      }

      if (
        Array.isArray(params?.disposition) &&
        params?.disposition.length > 0
      ) {
        queryParams.code = params.disposition.join(",");
        delete queryParams.disposition;
      }

      const response = await axios.get(TELECALLER_CASES_API_URL, {
        params: queryParams,

        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch users list",
      );
    }
  },
);
export const fetchTelecallerFieldAgents = createAsyncThunk(
  "agency/fetchTelecallerFieldAgents",
  async (params, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;
      if (!token) {
        return;
      }

      const response = await axios.get(TELECALLER_FIELD_AGENT_API_URL, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: params || {},
      });

      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch users list",
      );
    }
  },
);
export const fetchFieldAgentDetails = createAsyncThunk(
  "agency/fetchFieldAgentDetails",
  async (params, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;
      console.log(params, "kldjfkldjkfldjklfj");
      if (!token) {
        return;
      }

      const response = await axios.get(
        `${TELECALLER_FIELD_AGENT_DETAILS_API_URL}/${params?.id}/`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          params: params?.query || {},
        },
      );

      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch users list",
      );
    }
  },
);
export const fetchTelecallerFeedback = createAsyncThunk(
  "agency/fetchTelecallerFeedback",
  async (params, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;
      console.log(params, "kldjfkldjkfldjklfj");
      if (!token) {
        return;
      }

      const response = await axios.get(
        `${TELECALLER_FEEDBACK_DETAILS}/${params?.id}/`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          params: params?.query || {},
        },
      );

      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch users list",
      );
    }
  },
);

export const fetchTelecallerFeedbackCases = createAsyncThunk(
  "agency/fetchTelecallerFeedbackCases",
  async (params, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;
      const user = state.auth.user;

      if (!token) {
        return;
      }
      
      const userType = getUserType(user);
      const endpoint = userType === "telecaller" 
        ? "/telecaller/cases-with-feedback/" 
        : "/portfolio/cases-with-feedback/";
        
      const queryParams = { ...params };

      if (Array.isArray(params?.portfolios) && params?.portfolios.length > 0) {
        queryParams.portfolio = params.portfolios.join(",");
        delete queryParams.portfolios;
      }
      if (Array.isArray(params?.months) && params?.months.length > 0) {
        queryParams.month = normalizeMonthIds(params.months);
        delete queryParams.months;
      }

      if (Array.isArray(params?.states) && params?.states.length > 0) {
        queryParams.state = params.states.join(",");
        delete queryParams.states;
      }
      if (Array.isArray(params?.region) && params?.region.length > 0) {
        queryParams.region = params.region.join(",");
      }
      if (
        Array.isArray(params?.disposition) &&
        params?.disposition.length > 0
      ) {
        queryParams.code = params.disposition.join(",");
        delete queryParams.disposition;
      }
      if (params?.search && params?.search.trim() !== "") {
        queryParams.search = params.search.trim();
      }

      const response = await axios.get(endpoint, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: queryParams,
      });

      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch users list",
      );
    }
  },
);

export const fetchTelecallerPTPlist = createAsyncThunk(
  "agency/fetchTelecallerPTPlist",
  async (params, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;

      if (!token) {
        return;
      }
      const queryParams = { ...params };

     

      const response = await axios.get(`${TELECALLER_PTP_LIST}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: queryParams,
      });

      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch users list",
      );
    }
  },
);
export const fetchTelecallerCallbacklist = createAsyncThunk(
  "agency/fetchTelecallerCallbacklist",
  async (params, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;

      if (!token) {
        return;
      }
      const queryParams = { ...params };

      const response = await axios.get(`${TELECALLER_CALLBACK_LIST}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: queryParams,
      });

      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch users list",
      );
    }
  },
);

const initialState = {
  telecaller_cases: {},
  telecaller_cases_loading: false,
  telecaller_field_agents: {},
  telecaller_field_agents_loading: false,
  field_agent_details: {},
  field_agent_details_loading: false,
  feedback: {},
  feedback_loading: false,
  feedback_cases: {},
  feedback_cases_loading: false,
  ptp_list: {},
  ptp_list_loading: false,
  callback_list: {},
  callback_list_loading: false,
};
const telecallerCases = createSlice({
  name: "telecallerCases",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // telecaller allocated cases
      .addCase(fetchTelecallerAllocatedCase.pending, (state) => {
        state.telecaller_cases_loading = true;
      })
      .addCase(fetchTelecallerAllocatedCase.fulfilled, (state, action) => {
        state.telecaller_cases_loading = false;
        state.telecaller_cases = action.payload;
      })
      .addCase(fetchTelecallerAllocatedCase.rejected, (state, action) => {
        state.telecaller_cases_loading = false;
        state.telecaller_cases = {};
      })
      // telecaller field agents
      .addCase(fetchTelecallerFieldAgents.pending, (state) => {
        state.telecaller_field_agents_loading = true;
      })
      .addCase(fetchTelecallerFieldAgents.fulfilled, (state, action) => {
        state.telecaller_field_agents_loading = false;
        state.telecaller_field_agents = action.payload;
      })
      .addCase(fetchTelecallerFieldAgents.rejected, (state, action) => {
        state.telecaller_field_agents_loading = false;
        state.telecaller_field_agents = {};
      })

      // field agent details
      .addCase(fetchFieldAgentDetails.pending, (state) => {
        state.field_agent_details_loading = true;
      })
      .addCase(fetchFieldAgentDetails.fulfilled, (state, action) => {
        state.field_agent_details_loading = false;
        state.field_agent_details = action.payload;
      })
      .addCase(fetchFieldAgentDetails.rejected, (state, action) => {
        state.field_agent_details_loading = false;
        state.field_agent_details = {};
      })

      // telecaller feedback details
      .addCase(fetchTelecallerFeedback.pending, (state) => {
        state.feedback_loading = true;
      })
      .addCase(fetchTelecallerFeedback.fulfilled, (state, action) => {
        state.feedback_loading = false;
        state.feedback = action.payload;
      })
      .addCase(fetchTelecallerFeedback.rejected, (state, action) => {
        state.feedback_loading = false;
        state.feedback = {};
      })
      // telecaller feedback cases
      .addCase(fetchTelecallerFeedbackCases.pending, (state) => {
        state.feedback_cases_loading = true;
      })
      .addCase(fetchTelecallerFeedbackCases.fulfilled, (state, action) => {
        state.feedback_cases_loading = false;
        state.feedback_cases = action.payload;
      })
      .addCase(fetchTelecallerFeedbackCases.rejected, (state, action) => {
        state.feedback_cases_loading = false;
        state.feedback_cases = {};
      })
      // telecaller ptp list
      .addCase(fetchTelecallerPTPlist.pending, (state) => {
        state.ptp_list_loading = true;
      })
      .addCase(fetchTelecallerPTPlist.fulfilled, (state, action) => {
        state.ptp_list_loading = false;
        state.ptp_list = action.payload;
      })
      .addCase(fetchTelecallerPTPlist.rejected, (state, action) => {
        state.ptp_list_loading = false;
        state.ptp_list = {};
      })
      // telecaller callback list
      .addCase(fetchTelecallerCallbacklist.pending, (state) => {
        state.callback_list_loading = true;
      })
      .addCase(fetchTelecallerCallbacklist.fulfilled, (state, action) => {
        state.callback_list_loading = false;
        state.callback_list = action.payload;
      })
      .addCase(fetchTelecallerCallbacklist.rejected, (state, action) => {
        state.callback_list_loading = false;
        state.callback_list = {};
        });

  },
});

export default telecallerCases.reducer;
